import React from 'react'

import styled from '@emotion/styled'

import { getRelativeSizePt } from './basis'

const StyledEditableSpan = styled.span<{
  isUnderlined: boolean
  isSelected: boolean
  isEditable: boolean
}>`
  font-family: 'PT-Astra-Serif', serif;
  font-style: italic;
  font-weight: normal;
  text-decoration: none;
  font-size: inherit;

  line-height: ${getRelativeSizePt(16)};
  min-height: ${getRelativeSizePt(16)};
  background: rgba(146, 241, 227, 0.21);
  border-bottom: ${props => (props.isUnderlined ? '1pt solid black' : 'none')};
  padding-right: ${getRelativeSizePt(8)};
  padding-left: ${getRelativeSizePt(8)};

  color: black;

  cursor: pointer;
  outline: ${props =>
    props.isSelected ? '3pt solid #0666bf' : '0px solid transparent'};

  &:hover {
    outline: ${props => (props.isEditable ? '3pt solid #f6306f' : 'none')};
  }

  &:active {
    outline: 3pt solid #0666bf;
  }
`

type EditableSpanProps<T> = {
  id?: T
  onTextChange?: (textContent: string | null) => void
  onToggle?: (textContent: string | null) => void
  selectedId?: string
  isEditable?: boolean | undefined
  isUnderlined?: boolean
}

export function EditableSpan<T extends string>({
  onTextChange,
  onToggle,
  selectedId,
  isEditable = false,
  isUnderlined = true,
  ...rest
}: EditableSpanProps<T> & Omit<React.HTMLProps<HTMLSpanElement>, 'as'>) {
  return (
    <StyledEditableSpan
      isSelected={selectedId === rest.id}
      onBlur={event =>
        onTextChange?.((event.target as HTMLSpanElement).textContent)
      }
      onClick={
        onToggle
          ? (event: React.FormEvent<HTMLSpanElement>) =>
              onToggle((event.target as HTMLSpanElement).textContent)
          : undefined
      }
      {...rest}
      isEditable={isEditable}
      isUnderlined={isUnderlined}
    />
  )
}
